import $ from 'jquery'
import { convertDateToDdMmYyyy } from '@/function/function.js';
import Vue from 'vue';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)


export default {
    name: 'resultat-ge',
    components: {
        VueHtml2pdf, EnteteBonEtFacture
    },
    props: [],
    data () {
        return {
            date_resultat: '',           //  Date d'enregistrement du résultat
            user_role: '',
            result_loading: true,
        }
    },
    computed: {
        prescripteur(){
            return this.$store.getters["prescripteur"];
        },
        resultat(){
            return this.$store.getters["resultat"];
        },
        
        /**
         * User Info
         * @returns 
        */
         userCredentials() {
            return this.$store.getters['authInfo'];
        }
    },
    mounted () {
        
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);
        this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());  // Temporaire. NB : A remplacer par la date du resultat
        this.$store.dispatch("getDemandeResult",this.$route.params.resultat_id).then(
            () =>{
                this.result_loading = false

                
                if(this.resultat.user_id !== null)
                {
                    this.$store.dispatch("getPrescripteur",this.resultat.user_id)
                }
                else{
                    this.$store.commit("SET_PRESCRIPTEUR",null)
                }
                
                // if (this.resultat.numero == "" || this.resultat.numero == null) {

                // } else {

                // }
            }
        )

        console.log("RESULT: ", this.resultat)

        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;

        }
    },
    methods: {
        /**
         * Imprimer le resultat CRP
         */
         printResultatGE() {
            this.$refs.ge_html2Pdf.generatePdf()
        },

        async beforeDownload ({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'Le biologiste';
                let lome_le = this.ville_le+this.date_resultat;

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1.4))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1.4))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(8)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },  
        
        hasStartedGeneration() {
            
        },  

        hasGenerated(ev) {
            console.log(ev)
        }
    }
}


